import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { IMAGES } from '~/assets/assetsPath';
import config from '~/config';
import styles from './ServiceSpa.module.scss';
import ServiceSpaItem from './ServiceSpaItem';

const cx = classNames.bind(styles);

function ServiceSpa({ data }) {
    const navigate = useNavigate();
    return (
        <div className={cx('service')}>
            <div className={cx('service-title')}>
                <p>List of outstanding services</p>
            </div>

            <div className={cx('service-wrapper')}>
                <Row gutter={[32, 32]}>
                    <Col xs={24} sm={24} md={12} lg={6}>
                        <div
                            onClick={() => {
                                navigate(config.routes.spa);
                                localStorage.setItem('cate_id', data?.[0]?.id);
                            }}
                        >
                            <ServiceSpaItem
                                title={data?.[0]?.title}
                                image={IMAGES.ServiceSpa1}
                                content={data?.[0]?.description}
                                backgroundColor="#fff9fb"
                            />
                        </div>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={6}>
                        <div
                            onClick={() => {
                                navigate(config.routes.spa);
                                localStorage.setItem('cate_id', data?.[1]?.id);
                            }}
                        >
                            <ServiceSpaItem
                                title={data?.[1]?.title}
                                image={IMAGES.ServiceSpa2}
                                content={data?.[1]?.description}
                                backgroundColor="#fffcf4"
                            />
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={6}>
                        <div
                            onClick={() => {
                                navigate(config.routes.spa);
                                localStorage.setItem('cate_id', data?.[2]?.id);
                            }}
                        >
                            <ServiceSpaItem
                                title={data?.[2]?.title}
                                image={IMAGES.ServiceSpa3}
                                content={data?.[2]?.description}
                                backgroundColor="#f8f6ff"
                            />
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={6}>
                        <div
                            onClick={() => {
                                navigate(config.routes.spa);
                                localStorage.setItem('cate_id', data?.[3]?.id);
                            }}
                        >
                            <ServiceSpaItem
                                title={data?.[3]?.title}
                                image={IMAGES.ServiceSpa4}
                                content={data?.[3]?.description}
                                backgroundColor="#f8f6ff"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default ServiceSpa;
